import {
  AsYouType,
  getCountries,
  getCountryCallingCode,
  getExampleNumber,
  validatePhoneNumberLength,
} from 'libphonenumber-js';
import examples from 'libphonenumber-js/mobile/examples';

export const DEFAULT_COUNTRY_ISO = 'BR';
export const MAX_PHONE_INPUT_DIGITS = 20;

const regionNames = new Intl.DisplayNames(['pt-BR'], { type: 'region' });

export function normalizePhoneSearch(value) {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

export function countryFlagEmoji(iso) {
  return String(iso || '')
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(127397 + char.charCodeAt(0)));
}

function buildCountryOption(iso) {
  const ddi = getCountryCallingCode(iso);
  const name = regionNames.of(iso) || iso;
  const example = getExampleNumber(iso, examples);
  const placeholder = example?.formatNational() || 'Número de telefone';

  return {
    iso,
    ddi,
    name,
    flag: countryFlagEmoji(iso),
    placeholder,
    searchText: normalizePhoneSearch(`${iso} ${name} ${ddi}`),
  };
}

export const PHONE_COUNTRIES = getCountries()
  .map(buildCountryOption)
  .sort((a, b) => {
    if (a.iso === DEFAULT_COUNTRY_ISO) return -1;
    if (b.iso === DEFAULT_COUNTRY_ISO) return 1;
    return a.name.localeCompare(b.name, 'pt-BR');
  });

export function getDefaultPhoneCountry() {
  return PHONE_COUNTRIES.find((country) => country.iso === DEFAULT_COUNTRY_ISO) || PHONE_COUNTRIES[0];
}

export function formatPhoneForCountry(value, country) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  return new AsYouType(country?.iso || DEFAULT_COUNTRY_ISO).input(digits);
}

export function trimPhoneInputDigits(value) {
  return String(value || '')
    .replace(/\D/g, '')
    .slice(0, MAX_PHONE_INPUT_DIGITS);
}

export function formatLimitedPhoneForCountry(value, country) {
  const digits = trimPhoneInputDigits(value);
  if (!digits) return '';
  return formatPhoneForCountry(digits, country);
}

export function isPossiblePhoneForCountry(value, country) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return false;
  return !validatePhoneNumberLength(digits, country?.iso || DEFAULT_COUNTRY_ISO);
}
